import "./index.css";
import Search from "./Search.js";

export default function App() {
  return (
    <div className="App">
      <h1>Weather</h1>
      <Search />
    </div>
  );
}
